import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Button, Icon, theme } from '@sweetgreen/garnish';

import { useFeatureFlag } from '@order/LaunchDarkly';
import { useLocalizationContext } from '@order/Localization';

import { useScanToPayFeatureFlag } from '../../../ScanToPayScreen/ScanToPay.featureFlag';

export const HomeScreenMobileHeader = (props: HomeScreenMobileHeaderProps) => {
  const { isLoggedIn = false, onPressScanToPay } = props;
  const { t } = useLocalizationContext();

  const isScanToPayEnabled = useScanToPayFeatureFlag();
  const isScanInStoreEnabled = useFeatureFlag('CELS-1050-enable-paytronix');

  const label = isScanToPayEnabled
    ? t('scan-to-pay')
    : t('scan-to-pay-disabled');

  return (
    <View testID="home.mobile-header" style={styles.row}>
      {isLoggedIn && !isScanInStoreEnabled ? (
        <View>
          <Button
            testID="scan-to-pay.button"
            palette="secondary"
            size="xsmall"
            disabled={!isScanToPayEnabled}
            accessibilityRole="link"
            accessibilityLabel={label}
            accessibilityHint={label}
            onPress={onPressScanToPay}
            style={styles.cta}
          >
            {label}
          </Button>
        </View>
      ) : (
        <Icon
          name="IconSweetgreen"
          color={theme.colors.KALE}
          width={40}
          height={40}
        />
      )}
    </View>
  );
};

// ─── Styles ───────────────────────────────────────────────────────

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    height: 56,
  },
  cta: {
    minHeight: 24,
    height: 'auto',
  },
});

// ─── Types ────────────────────────────────────────────────────────

type HomeScreenMobileHeaderProps = Readonly<{
  isLoggedIn: boolean;
  onPressScanToPay?: () => void;
}>;
